<template>
  <div>
    <div
      class="flex w-full flex-col rounded-[8px] text-[14px] hover:bg-alice-blue-100 md:text-[18px]"
    >
      <input
        :id="getRadioBtnId"
        type="radio"
        class="hidden"
        :checked="isChecked"
        @change="handleChange"
      />
      <label :for="getRadioBtnId" class="flex cursor-pointer p-3 md:p-4">
        <span
          class="box-contain relative mr-2 flex h-4 min-w-[16px] items-center justify-center rounded-50% border-2 border-black-100 text-white-100 md:mr-7 md:h-5 md:min-w-5"
        >
          <div
            v-if="isChecked"
            class="size-[8px] rounded-50% bg-black-100 md:size-[12px]"
          ></div>
        </span>
        <span
          class="flex items-center text-[14px] leading-[18px] text-new-test-black md:text-[18px] md:leading-[22px]"
        >
          {{ data.title }}
        </span>
      </label>
      <span
        v-if="currentlyCheckedId && countAnswered"
        class="answer ml-6 mt-[-6px] hidden pb-[5px] text-[10px] leading-[9px] md:ml-[65px] md:mt-[-15px] md:text-[14px] md:leading-[17px]"
        :class="data.is_right ? 'answer__correct' : 'answer__incorrect'"
        >(Такой ответ дали {{ countAnswered }} %)</span
      >
      <div
        v-if="data?.image"
        class="mb-4 ml-3 h-[152px] w-full max-w-[200px] cursor-pointer overflow-hidden rounded-xl md:ml-[64px]"
        @click="handleChange"
      >
        <img
          v-lazy-load
          :src="data?.image?.src"
          alt=""
          class="h-inherit w-full object-cover"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  currentlyCheckedId: {
    type: Number,
    default: null,
  },

  data: {
    type: Object,
    default: () => ({}),
  },

  disabled: {
    type: Boolean,
    default: false,
  },

  updateQuestionAnswered: {
    type: Number,
    default: 0,
  },

  countQuestionAnswer: {
    type: Number,
    default: 0,
  },
});
const emit = defineEmits([
  'update:currently-checked-id',
  'update-count-answer',
]);

/** computed */
const getRadioBtnId = computed(() => {
  return `radio-${props.data?.id}`;
});

const isChecked = computed(() => {
  return props.currentlyCheckedId === props.data?.id;
});

const countAnswered = computed(() => {
  if (!props.updateQuestionAnswered) return;

  return props.countQuestionAnswer > 0
    ? (
        (props.countQuestionAnswer * 100) /
        (props.updateQuestionAnswered - 1)
      ).toFixed(2)
    : '0';
});

/** methods */
const handleChange = () => {
  if (!props.disabled) emit('update:currently-checked-id', props.data.id);
  if (!props.disabled) emit('update-count-answer');
};
</script>

<style lang="scss">
.answer {
  &__correct {
    @apply flex text-correct;
  }

  &__incorrect {
    @apply flex text-ruby-red-100;
  }
}
</style>
